module.exports = "<div class=\"filter-group\">\r\n    <h4 class=>\r\n        {{Model.Label}}\r\n    </h4>\r\n    <li class=\"filters-region\">\r\n\r\n    </li>\r\n    {{#Model.ShowSelectAllButton}}\r\n    <div class=\"row filter-row\">\r\n        <label class=\"select-all-filters\">\r\n            <input type=\"checkbox\" class=\"select-all checkbox checkbox-filter\">\r\n            <span class=\"label-text\">Select all</span>\r\n        </label>\r\n    </div>\r\n    {{/Model.ShowSelectAllButton}}\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/search/views/advanced-search/advanced-search-filter-group.html
// module id = 398
// module chunks = 1